import React, { useEffect, useState } from "react";
import { AppDispatch } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { editSpa } from "../../../redux/actions/spa.actions";
import RootState from "../../../redux/states/root.state";
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import ModalShell, { ModalLoading } from "../../../components/common/Modals/ModalShell";
import { clearError } from "../../../redux/reducers/spa.reducer";

export const SERIAL_LENGTH = 6;


const EditSerialModal: React.FC<ModalProps> = ({open, setOpen}) => {
    const dispatch: AppDispatch = useDispatch();
    const {data:spa, error: spaError} = useSelector((state: RootState) => state.spa);
    const [input, setInput] = useState(``);
    const [submitted, setSubmitted] = useState(false);
    const [success, setSuccess] = useState(false);
    const [updating, setUpdating] = useState(false);
    // Only show errors from this modal's own request, not the page's fetches on the same slice.
    const error = submitted ? spaError : null;

    useEffect(() => {
        if (spa && open) {
          setInput(spa.arctic_serial_number??'');
        }
    }, [spa, open])

    const handleClose = () => {
      dispatch(clearError());
      setInput(``);
      setSubmitted(false);
      setSuccess(false);
      setOpen(false);
    };

    /* Handle text input: digits only, at most 6 */
    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        let input = e.target.value.replace(/\D/g, '').slice(0, SERIAL_LENGTH);
        setInput(input);
    };

    const isValid = new RegExp(`^\\d{0,${SERIAL_LENGTH}}$`).test(input);

    const handleEdit = async () => {
      if (!isValid) return;
      setSubmitted(true);
      setUpdating(true);
        const result = await dispatch(editSpa({guid:spa?.id,arctic_serial_number:input}));
        setSuccess(editSpa.fulfilled.match(result));
        setUpdating(false);
    }

  const done = Boolean(error) || success;

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      size="sm"
      busy={updating}
      tone={updating ? undefined : error ? "error" : success ? "success" : undefined}
      title={updating ? "Updating spa…" : error ? "An error occurred" : success ? "Serial number updated" : "Edit serial number"}
      subtitle={!updating && !done ? "The Arctic serial number on the spa's label." : undefined}
      actions={updating ? undefined : done ?
        <button className="btn btn-primary" onClick={handleClose}>Done</button>
        :
        <>
          <button className="btn" onClick={handleClose}>Cancel</button>
          <button className="btn btn-primary" onClick={handleEdit} disabled={!isValid}>Save</button>
        </>
      }
    >
      {updating ?
        <ModalLoading/>
        : error ?
        <p>{error}</p>
        : success ?
        <p>The spa's serial number was successfully updated.</p>
        :
        <form className="field" onSubmit={(e) => { e.preventDefault(); handleEdit(); }}>
          <label className="field-label" htmlFor="spa-serial-input">Serial number</label>
          <input
            id="spa-serial-input"
            className="input"
            type="text"
            inputMode="numeric"
            pattern={`\\d{0,${SERIAL_LENGTH}}`}
            maxLength={SERIAL_LENGTH}
            value={input}
            onChange={handleInput}
            aria-invalid={input.length > 0 && !isValid}
            autoFocus
          />
        </form>
      }
    </ModalShell>
  );
};

export default EditSerialModal;
